/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-30 14:05:17
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import validateColor from 'validate-color';

/**
 * Build initial data for swatch settings
 *
 * @param  {Object} swatchSettings value from API
 *
 * @return {Object} initialValue
 */
export const buildInitialValues = swatchSettings => {
  if (_.isEmpty(swatchSettings)) {
    return [];
  }
  let result = [];
  swatchSettings.map((item, key) => {
    let swatchSetting = { ...item };

    const { colorCodes = [] } = swatchSetting;

    // Prepares colorCodes
    swatchSetting.colorCode01 = colorCodes[0] || '';
    swatchSetting.colorCode02 = colorCodes[1] || '';
    swatchSettings.colorCodes = undefined;
    result.push(swatchSetting);
    return '';
  });
  return { swatchSettings: result };
};

/**
 * Build swatch settingss before saving
 *
 * @param  {array} swatchSettings list of swatchSettings
 *
 *  * @return {Object} save product
 */
export const buildSwatchSettingsValues = swatchSettings => {
  if (_.isEmpty(swatchSettings)) {
    return [];
  }

  let result = [];
  swatchSettings.map((item, key) => {
    let swatchSetting = { ...item };

    const { colorCode01, colorCode02, type } = swatchSetting;

    // Prepares colorCodes
    switch (type) {
      case 'oneColor': {
        swatchSetting.colorCodes = [colorCode01];
        break;
      }
      case 'twoColors': {
        swatchSetting.colorCodes = [colorCode01, colorCode02];
        break;
      }
      case 'image': {
        swatchSetting.colorCodes = [];
        break;
      }
      default:
        swatchSetting.colorCodes = [];
    }
    swatchSetting.colorCode01 = undefined;
    swatchSetting.colorCode02 = undefined;
    swatchSetting.imageUrl = swatchSetting.imageUrl
      ? swatchSetting.imageUrl.trim()
      : swatchSetting.imageUrl;
    result.push(swatchSetting);
    return '';
  });

  return result;
};

/**
 * Validate swatch settings before saving
 *
 * @param  {array} swatchSettings list of swatchSettings
 *
 *  * @return {Object} save product
 */
export const checkValidateSettings = (swatchSettings, i18n) => {
  let globalError = [],
    swatchSettingsError = [];
  swatchSettings.map((swatchSetting, index) => {
    let colorCode01Error = '';
    let colorCode02Error = '';
    let notSelectTypeError = '';

    if (!swatchSetting.type && !_.isEmpty(swatchSetting.colorCode01)) {
      notSelectTypeError = i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_DisplayType');
    }

    // Check color
    if (swatchSetting.type === 'oneColor' || swatchSetting.type === 'twoColors') {
      if (_.isEmpty(swatchSetting.colorCode01)) {
        colorCode01Error = i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_EmptyColor');
      } else {
        if (!validateColor(swatchSetting.colorCode01)) {
          colorCode01Error = i18n.translate(
            'AdminHTML.SwatchSettings.Validate.invalid_ColorFormat'
          );
        }
      }
    }
    if (swatchSetting.type === 'twoColors') {
      if (_.isEmpty(swatchSetting.colorCode02)) {
        colorCode02Error = i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_EmptyColor');
      } else {
        if (!validateColor(swatchSetting.colorCode02)) {
          colorCode02Error = i18n.translate(
            'AdminHTML.SwatchSettings.Validate.invalid_ColorFormat'
          );
        }
      }
    }

    if (!_.isEmpty(notSelectTypeError) && !globalError.includes(notSelectTypeError)) {
      globalError.push(notSelectTypeError);
    }

    if (!_.isEmpty(colorCode01Error)) {
      swatchSettingsError[index] = { colorCode01: colorCode01Error };
      if (!globalError.includes(colorCode01Error)) {
        globalError.push(colorCode01Error);
      }
    }

    if (!_.isEmpty(colorCode02Error)) {
      if (_.isEmpty(swatchSettingsError[index])) {
        swatchSettingsError[index] = { colorCode02: colorCode02Error };
      } else {
        swatchSettingsError[index] = {
          ...swatchSettingsError[index],
          colorCode02: colorCode02Error
        };
      }
      if (!globalError.includes(colorCode02Error)) {
        globalError.push(colorCode02Error);
      }
    }

    return '';
  });
  return { globalError, swatchSettingsError };
};
